<aside class="flex h-full w-full flex-col overflow-hidden bg-(--surface)">
  <div class="border-b border-(--border-subtle) px-3 py-4">
    <p class="text-xs font-semibold uppercase tracking-wider text-(--text-default)/70">
      {{ 'shell.sidebar.navigation' | translate }}
    </p>
    <p class="mt-1 text-sm text-(--text-default)">
      {{ 'shell.sidebar.mainAccess' | translate }}
    </p>
  </div>

  <nav class="flex-1 overflow-y-auto px-2 py-3">
    <ul class="space-y-1">
      @for (item of visibleItems(); track item.id) {
        @if (item.dividerBefore) {
          <li class="my-3 border-t border-(--border-subtle)"></li>
        }

        <li>
          @if (!item.children?.length) {
            <a
              [routerLink]="item.fullRoute"
              routerLinkActive="sidebar-link-active"
              (click)="onLeafItemClick()"
              class="sidebar-link group flex min-h-10 items-center gap-2.5 rounded-xl px-2.5 py-2 text-sm font-medium">
              <mat-icon class="shrink-0 h-6! w-6! text-[22px]! leading-none">
                {{ item.icon }}
              </mat-icon>

              <span class="min-w-0 wrap-break-word whitespace-normal leading-5">
                {{ item.label | translate }}
              </span>
            </a>
          } @else {
            <button
              type="button"
              (click)="toggle(item)"
              class="sidebar-link group flex min-h-10 w-full items-center gap-2.5 rounded-xl px-2.5 py-2 text-left text-sm font-medium">
              <mat-icon class="shrink-0 h-6! w-6! text-[22px]! leading-none">
                {{ item.icon }}
              </mat-icon>

              <span class="min-w-0 flex-1 wrap-break-word whitespace-normal leading-5">
                {{ item.label | translate }}
              </span>

              <mat-icon class="shrink-0 h-5! w-5! text-[20px]! leading-none opacity-70">
                {{ item.expanded ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </button>

            @if (item.expanded) {
              <ul class="mt-1 space-y-1 pl-4">
                @for (child of item.children; track child.id) {
                  <li>
                    <a
                      [routerLink]="child.fullRoute"
                      routerLinkActive="sidebar-link-active"
                      (click)="onLeafItemClick()"
                      class="sidebar-link group flex min-h-9 items-center gap-2.5 rounded-xl px-2.5 py-1.5 text-sm">
                      <mat-icon class="shrink-0 h-5! w-5! text-[20px]! leading-none opacity-80">
                        {{ child.icon }}
                      </mat-icon>

                      <span class="min-w-0 wrap-break-word whitespace-normal leading-5">
                        {{ child.label | translate }}
                      </span>
                    </a>
                  </li>
                }
              </ul>
            }
          }
        </li>
      }
    </ul>
  </nav>

  <div class="border-t border-(--border-subtle) p-2">
    <button
      type="button"
      (click)="onLogout()"
      class="flex min-h-10 w-full items-center gap-2.5 rounded-xl px-2.5 py-2 text-sm font-medium text-(--bimbo-red) transition-colors duration-200 hover:bg-(--bimbo-red) hover:text-white">
      <mat-icon class="shrink-0 h-5! w-5! text-[20px]! leading-none"> logout </mat-icon>

      <span class="min-w-0 wrap-break-word whitespace-normal leading-5">
        {{ 'shell.actions.logout' | translate }}
      </span>
    </button>
  </div>
</aside>
